
const countries = [
  {
    code: 'bg',
    name: 'bulgaria',
    subtitle: 'discover wine regions',
    image: require('@/assets/img/atlas/bulgaria.jpg'),
    flag: require('@/assets/img/atlas/flags/bg.png'),
    available: true,
    route: '/countries/bulgaria'
  },
  {
    code: 'fr',
    name: 'france',
    subtitle: 'available soon',
    image: require('@/assets/img/atlas/france.jpg'),
    flag: require('@/assets/img/atlas/flags/fr.png'),
    available: false,
    route: ''
  },
  {
    code: 'it',
    name: 'italy',
    subtitle: 'available soon',
    image: require('@/assets/img/atlas/italy.jpg'),
    flag: require('@/assets/img/atlas/flags/it.png'),
    available: false,
    route: ''
  },
  {
    code: 'es',
    name: 'spain',
    subtitle: 'available soon',
    image: require('@/assets/img/atlas/spain.jpg'),
    flag: require('@/assets/img/atlas/flags/es.png'),
    available: false,
    route: ''
  },
  {
    code: 'pt',
    name: 'portugal',
    subtitle: 'available soon',
    image: require('@/assets/img/atlas/portugal.jpg'),
    flag: require('@/assets/img/atlas/flags/pt.png'),
    available: false,
    route: ''
  },
  {
    code: 'de',
    name: 'germany',
    subtitle: 'available soon',
    image: require('@/assets/img/atlas/germany.jpg'),
    flag: require('@/assets/img/atlas/flags/de.png'),
    available: false,
    route: ''
  }
];

export default countries;